// Generated by apps/web/scripts/build-stock.mjs — do not edit by hand.
// Run `npm run stock` to regenerate.

/** Ball images available to Quick Play, served from /stock/. */
export const STOCK_BALLS = [
  'abraham-lincoln.webp',
  'alysa-liu.webp',
  'barack-obama.webp',
  'ceelo-green.webp',
  'colonel-harland-sanders-gettyimages-72431338.webp',
  'daisy-ridley.webp',
  'dwayne-johnson.webp',
  'eminem.webp',
  'ethan-slater.webp',
  'george-lucas.webp',
  'grant-gustin.webp',
  'greta-thunberg.webp',
  'haaland.webp',
  'harrison-ford.webp',
  'jason-derulo.webp',
  'jhud.webp',
  'john-green.webp',
  'john-legend.webp',
  'john-mayer.webp',
  'judge-judy.webp',
  'kamala.webp',
  'kevin-jonas.webp',
  'kim-kardashian.webp',
  'mona-lisa.webp',
  'mr-bean.webp',
  'pedro-pascal.webp',
  'pharrell.webp',
  'queen-elizabeth.webp',
  'robert-deniro.webp',
  'ruth-bader-ginsburg-2016-portrait.webp',
  'sam-jackson.webp',
  'sean-astin.webp',
  'serena-williams.webp',
  'shakespeare.webp',
  'simu-liu.webp',
  'stellan.webp',
  'taylor-swift.webp',
  'tony-leung.webp',
  'wallace-shawn.webp',
  'zlatan.webp',
] as const;
